import moment from 'moment-timezone';

// Business time is Warsaw, independently of the learner's display timezone.
export const oneMonthBookingHorizonEnd = (now = Date.now()) => (
  moment(now).tz('Europe/Warsaw').add(1, 'month').toISOString()
);

export const resolveBookingHorizonEnd = (serverEnd, now = Date.now()) => (
  serverEnd && moment(serverEnd, moment.ISO_8601, true).isValid()
    ? moment(serverEnd).toISOString() : oneMonthBookingHorizonEnd(now)
);

// Inclusive by lesson START; the lesson may finish after this cap.
export const isBookingStartWithinHorizon = (start, horizonEnd) => {
  if (!start || !horizonEnd) return false;
  const time = new Date(start).getTime();
  const cap = new Date(horizonEnd).getTime();
  return Number.isFinite(time) && Number.isFinite(cap) && time <= cap;
};

// Leave room for a lesson ending after the inclusive start boundary when
// calling legacy availability validation, which checks the lesson's end.
export const availabilityHorizonOptions = (horizonEnd, now = Date.now()) => (
  horizonEnd && Number.isFinite(new Date(horizonEnd).getTime())
    ? { maxDays: Math.ceil((new Date(horizonEnd).getTime() - now) / 86400000) + 1 }
    : {}
);

export const isBookingWindowError = (error) => (
  ['BOOKING_TOO_FAR', 'TRIAL_BOOKING_TOO_FAR'].includes(error?.code || error?.errorCode || error?.response?.data?.code || error?.response?.data?.errorCode)
);

export const bookingWindowErrorMessage = (translate, language = 'pl') => translate('booking.bookingTooFar', {
  defaultValue: String(language).toLowerCase().startsWith('en')
    ? 'You can book a trial lesson up to one month ahead. Choose an earlier time.'
    : 'Lekcję próbną możesz zarezerwować maksymalnie miesiąc do przodu. Wybierz wcześniejszy termin.',
});
